<template>
  <a-table
    class="custom-table"
    :columns="columns"
    :data-source="dataSource"
    :scroll="{ x: scrollX, y: 720 }"
    :pagination="false"
    :loading="loading"
    :components="components"
    row-key="id"
  >
    <template slot="localAddress" slot-scope="text">
      <a-tooltip v-if="text" :title="text">{{ text }}</a-tooltip>
      <span v-else>-</span>
    </template>
    <template slot="mapAddress" slot-scope="text">
      <a-tooltip v-if="text" :title="text" >{{ text }}</a-tooltip>
      <span v-else>-</span>
    </template>
    <template slot="description" slot-scope="text">
      <a-tooltip v-if="text" :title="text">{{ text }}</a-tooltip>
      <span v-else>-</span>
    </template>
    <template slot="operation" slot-scope="text, record, index">
      <edit-button
        @click="$emit('edit', record)"
      ></edit-button>
      <delete-button @confirm="confirm(record.id, index)"></delete-button>
    </template>
  </a-table>
</template>

<script>
import { getOSMonitorPortList, deleteOSMonitorPort } from '@/api/os.js'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'PortTable',
  components: {
    DeleteButton,
    EditButton
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    refresh: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      columns: [
        {
          dataIndex: 'local_address',
          title: '本地地址',
          width: 230,
          ellipsis: true,
          scopedSlots: {
            customRender: 'localAddress'
          }
        },
        {
          dataIndex: 'map_address',
          title: '映射地址',
          width: 230,
          ellipsis: true,
          scopedSlots: {
            customRender: 'mapAddress'
          }
        },
        {
          dataIndex: 'description',
          title: '描述',
          width: 280,
          ellipsis: true,
          scopedSlots: {
            customRender: 'description'
          }
        },
        {
          dataIndex: 'operation',
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 180,
          scopedSlots: {
            customRender: 'operation'
          }
        }
      ],
      dataSource: [],
      components: {
        header: {}
      }
    }
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        sum += column.width
      })
      return sum
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    confirm (id, index) {
      deleteOSMonitorPort(id).then(res => {
        this.$message.success(res.message)
        this.dataSource.splice(index, 1)
      })
    },
    fetch () {
      this.loading = true
      getOSMonitorPortList(this.detail.id).then(res => {
        this.dataSource = res.data.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    refresh () {
      this.fetch()
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-table-fixed-header .ant-table-scroll .ant-table-header::-webkit-scrollbar) {
  display: none !important;
  border: none !important;
}
</style>
